import InactivityModal from './InactivityModal'

export default InactivityModal
